import {
  CommissionsVisibility,
  PaymentTypes,
  StudioType,
  TimeStep,
} from "../../../../../common/enums";
import {
  CommissionsVisibilityLabels,
  StudioTypeLabels,
  TimeStepLabels,
} from "../../../../../common/labels";

export const getStudioType = () => [
  { id: StudioType.Group, name: StudioTypeLabels[StudioType.Group] },
  { id: StudioType.Service, name: StudioTypeLabels[StudioType.Service] },
  { id: StudioType.Gym, name: StudioTypeLabels[StudioType.Gym] },
  { id: StudioType.Store, name: StudioTypeLabels[StudioType.Store] },
];

export const getTimeStep = () => [
  { id: TimeStep.FifteenMins, name: TimeStepLabels[TimeStep.FifteenMins] },
  { id: TimeStep.ThirtyMins, name: TimeStepLabels[TimeStep.ThirtyMins] },
  { id: TimeStep.OneHour, name: TimeStepLabels[TimeStep.OneHour] },
];

export const getCommissionsVisibility = () => [
  {
    id: CommissionsVisibility.Both,
    name: CommissionsVisibilityLabels[CommissionsVisibility.Both],
  },
  {
    id: CommissionsVisibility.MoneyOnly,
    name: CommissionsVisibilityLabels[CommissionsVisibility.MoneyOnly],
  },
  {
    id: CommissionsVisibility.EventsOnly,
    name: CommissionsVisibilityLabels[CommissionsVisibility.EventsOnly],
  },
  {
    id: CommissionsVisibility.None,
    name: CommissionsVisibilityLabels[CommissionsVisibility.None],
  },
];

/**
 * Payment methods kept but not shown in "Поддържани начини на плащане". "Абонаментна карта"
 * is hidden while the studio does not use plans; whatever is stored for it stays, so cards
 * already sold keep working and the option comes back as it was when plans are switched on.
 */
export const getHiddenPaymentTypes = (studioDoesNotUsePlans: boolean) =>
  studioDoesNotUsePlans ? [PaymentTypes.Plan] : [];
